import {
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaTelegramPlane,
  FaFacebook,
  FaEnvelope,
  FaCopy,
} from "react-icons/fa";

import openseaIcon from "../images/icon/opensea.svg";
import mediumIcon from "../images/icon/med.svg"; 

const data = [
  {
    thumb: openseaIcon,
    url: "#",
  },
  {
    icon: <FaTwitter />,
    url: "https://twitter.com/alphaoctopusnft",
  },
  {
    icon: <FaLinkedinIn />,
    url: "#",
  },
  {
    icon: <FaFacebook />,
    url: "#",
  },
  {
    icon: <FaInstagram />,
    url: "#",
  },
  {
    icon: <FaTelegramPlane />,
    url: "#",
  },
  {
    thumb: mediumIcon,
    url: "#",
  }, 
  {
    icon: <FaEnvelope />,
    url: "#",
  },
  {
    icon: <FaCopy />,
    url: "#",
  },
];

export default data;
